module.exports = __webpack_public_path__ + "img/y16.9f1dd6ee.jpg";